import { companyReducer } from "../reducer/CompanyReducer";

export const reducer = companyReducer;
